import { useState, useEffect } from "react";
import { useLanguage } from "@/hooks/useLanguage";
import { Button } from "./ui/button";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

export const CookieConsent = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="container mx-auto">
        <div className="gradient-card rounded-2xl p-6 shadow-elevated border border-border/50 max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 gradient-bg rounded-xl flex items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-primary-foreground" />
            </div>
            
            <div className="flex-1">
              <h3 className="font-semibold text-foreground mb-1">
                {t("Ми використовуємо cookies", "We use cookies")}
              </h3>
              <p className="text-sm text-muted-foreground">
                {t(
                  "Цей сайт використовує cookies для покращення вашого досвіду. Продовжуючи, ви погоджуєтесь з нашою ",
                  "This site uses cookies to improve your experience. By continuing, you agree to our "
                )}
                <Link to="/privacy" className="text-primary hover:underline">
                  {t("Політикою конфіденційності", "Privacy Policy")}
                </Link>
                .
              </p>
            </div>

            <div className="flex gap-3 flex-shrink-0">
              <Button
                variant="outline"
                size="sm"
                onClick={declineCookies}
                className="text-muted-foreground"
              >
                {t("Відхилити", "Decline")}
              </Button>
              <Button
                variant="default"
                size="sm"
                onClick={acceptCookies}
                className="gradient-bg text-primary-foreground"
              >
                {t("Прийняти", "Accept")}
              </Button>
            </div>

            <button
              onClick={declineCookies}
              className="absolute top-4 right-4 md:hidden text-muted-foreground hover:text-foreground"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
